// material-ui
import Box from '@mui/material/Box';

import markUrl from 'assets/images/logo/familia-mark.svg';

// ==============================|| LOGO ICON (sidebar recolhida) ||============================== //
// Marca da família mascarada e colorida pelo tema (primary.main), adaptando dark/light.

export default function LogoIcon() {
  return (
    <Box
      aria-label="Família"
      sx={{
        width: 34,
        height: 34,
        backgroundColor: 'primary.main',
        WebkitMaskImage: `url(${markUrl})`,
        maskImage: `url(${markUrl})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center'
      }}
    />
  );
}
